import { HomeState } from "./types";
import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { RootState } from "../../store/rootReducer";
import { API_URL } from "config";

const initialState: HomeState = {
  data: undefined,
};

const home = createSlice({
  name: "homeSlice",
  initialState,
  reducers: {
    setHomeData(state, action) {
      state.data = action.payload;
    },
  },
});
export const { setHomeData } = home.actions;
export const selectHomeData = (state: RootState) => state.home.data;
export const getHomeData = () => async (dispatch: any) => {
  try {
    const res = await axios.get(`${API_URL}/`);
    dispatch(setHomeData(res.data));
  } catch (error: any) {
    alert(error);
  }
};
export default home.reducer;
